import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Injects one or more JSON-LD graphs into <head>.
 * Accepts a single object, an array, or null/undefined entries (filtered out).
 */
const JsonLd = ({ data }) => {
  const graphs = (Array.isArray(data) ? data : [data]).filter(Boolean);
  if (graphs.length === 0) return null;

  return (
    <Helmet>
      {graphs.map((graph, index) => (
        <script
          // Stable enough within a page; order is intentional for debugging.
          key={`jsonld-${index}-${graph["@type"] || "graph"}`}
          type="application/ld+json"
        >
          {JSON.stringify(graph)}
        </script>
      ))}
    </Helmet>
  );
};

export default JsonLd;
